export function getCountries(oldCountries: string[], toggleList: string[]) {
  const allChecked = toggleList.every((id) => oldCountries.includes(id));

  if (allChecked) {
    return oldCountries.filter((c) => !toggleList.includes(c));
  }

  const newChecks = toggleList.filter((tL) => !oldCountries.includes(tL));
  return oldCountries.concat(newChecks);
}
